<template>
  <div class="student-support-status" role="status">
    <span class="student-support-status__label" title="ดูข้อมูลและสร้าง QR ชำระเงินได้ ไม่สามารถแก้ข้อมูลหรือเปลี่ยนรหัสผ่าน">โหมดผู้ดูแล · ช่วยชำระเงิน</span>
    <span class="student-support-status__expiry">หมดอายุ {{ expiresAt }}</span>
    <button type="button" class="student-support-status__exit" aria-label="ออกจากโหมดผู้ดูแล" @click="exitSupport">ออกจากโหมด</button>
  </div>
</template>

<script>
import { supportState, endSupport } from '@/utils/student-support-session'

export default {
  name: 'StudentSupportStatus',
  computed: {
    expiresAt () { return supportState.expiresAt ? new Date(supportState.expiresAt).toLocaleTimeString('th-TH') : '' }
  },
  methods: {
    exitSupport () { endSupport('ออกจากโหมดผู้ดูแลแล้ว สามารถปิดแท็บนี้ได้') }
  }
}
</script>

<style scoped>
.student-support-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: .35rem .8rem;
  min-width: 0;
  font-size: .85rem;
  line-height: 1.5;
  color: inherit;
}
.student-support-status__label { font-weight: 500; }
.student-support-status__expiry { opacity: .8; white-space: nowrap; }
.student-support-status__exit {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: .25rem .6rem;
  color: inherit;
  font: inherit;
  white-space: nowrap;
  cursor: pointer;
}
.student-support-status__exit:hover { background: rgba(128, 128, 128, .08); }
.student-support-status__exit:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
</style>
